import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Table, Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowTrendUp,
  faArrowTrendDown,
  faCalendarAlt,
  faEllipsisV,
  faBitcoinSign,
  faCoins
} from '@fortawesome/free-solid-svg-icons';
const style = `
.coin-glass-bg {
  background: rgba(24, 26, 32, 0.85);
  border-radius: 2rem;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.18);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255,255,255,0.08);
  padding: 2rem 1rem;
  margin: 0 auto;
}
.coin-table thead {
  background: rgba(40, 44, 52, 0.7);
  font-size: 0.85rem;
  letter-spacing: 0.08em;
  color: #ffffffff;
  border-bottom: 1px solid rgba(255,255,255,0.06);
}
.coin-table tbody tr {
  transition: background 0.18s;
  color: #fff;  
}
.coin-table tbody tr:hover {
  background: rgba(255,255,255,0.03);
}
.coin-table td, .coin-table th {
  vertical-align: middle;
  padding: 0.7rem 0.5rem;
  font-size: 0.92rem;
}
.coin-pair {
  display: flex;
  align-items: center;
  gap: 0.7rem;
}
.coin-icon {
  background: linear-gradient(135deg, #23272f 60%, #2d313a 100%);
  border-radius: 50%;
  width: 2.2rem;
  height: 2.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px 0 rgba(0,0,0,0.10);
}
.coin-name {
  font-weight: 600;
  font-size: 1rem;
  color: #fff;
  letter-spacing: 0.01em;
}
.coin-tag {
  background: rgba(60, 65, 80, 0.7);
  color: #ffffffff;
  border-radius: 0.5rem;
  font-size: 0.68rem;
  padding: 0.13rem 0.6rem;
  margin-top: 0.18rem;
  display: inline-block;
}
.coin-profit-up {
  color: #3fe08f;
}
.coin-profit-down {
  color: #ff5e5e;
}
.coin-profit {
  font-weight: 600;
  font-size: 0.98rem;
}
.coin-trend {
  font-size: 0.78rem;
  margin-left: 0.3rem;
  opacity: 0.8;
}
.coin-table td, .coin-table th {
  border: none !important;
}
@media (max-width: 600px) {
  .coin-glass-bg {
    padding: 1rem 0.2rem;
    border-radius: 1.2rem;
    max-width: 100vw;
  }
  .coin-table thead {
    font-size: 0.72rem;
  }
  .coin-table td, .coin-table th {
    font-size: 0.78rem;
    padding: 0.45rem 0.2rem;
  }
  .coin-name { font-size: 0.92rem; }
  .coin-icon { width: 1.6rem; height: 1.6rem; }
}
::-webkit-scrollbar { height: 6px; background: transparent; }
::-webkit-scrollbar-thumb { background: #23272f; border-radius: 6px; }
`;
const CoinAllocation = () => {
  const data = [
    {
      icon: <FontAwesomeIcon icon={faBitcoinSign} color="#f7931a" size="lg" />,
      name: 'Bitcoin',
      tag: 'BTC',
      orderQty: 0,
      price: '$43,318.64',
      avgBuy: '$38,235.25',
      holdings: '0.10565',
      total: '$10,12.64',
      profit: '+ $43,318.64',
      profitPercent: '+0.60%',
      profitColor: 'coin-profit-up',
      trendIcon: <FontAwesomeIcon icon={faArrowTrendUp} className='coin-trend' />
    },
    {
      icon: <FontAwesomeIcon icon={faCoins} color="#346aa9" size="lg" />,
      name: 'XPR',
      tag: 'XPR',
      orderQty: 0,
      price: '$0.00917',
      avgBuy: '$0.01773',
      holdings: '150',
      total: '$10,12.64',
      profit: '+ $120.00',
      profitPercent: '+3.60%',
      profitColor: 'coin-profit-up',
      trendIcon: <FontAwesomeIcon icon={faArrowTrendUp} className='coin-trend' />
    },
    {
      icon: <FontAwesomeIcon icon={faCoins} color="#b8b8b8" size="lg" />,
      name: 'Litecoin',
      tag: 'LTC',
      orderQty: 0,
      price: '$43,318.64',
      avgBuy: '$38,235.25',
      holdings: '5',
      total: '$10,12.64',
      profit: '- $43,318.64',
      profitPercent: '-1.60%',
      profitColor: 'coin-profit-down',
      trendIcon: <FontAwesomeIcon icon={faArrowTrendDown} className='coin-trend' />
    }
  ];

  return (
    <>
      <style>{style}</style>
      <Container fluid className="d-flex flex-column align-items-center justify-content-center  bg-black">
        <Row className="bg-bw-100 justify-content-between align-items-center mb-4" style={{ maxWidth: 900 }}>
          <Col>
            <h5 className="fw-bold text-white mb-0" style={{ letterSpacing: '0.01em', fontSize: '1.25rem' }}>
              Coin Allocation
            </h5>
          </Col>
          <Col xs="auto" className="d-flex align-items-center gap-3">
            <div className="d-flex align-items-center text-secondary" style={{ fontSize: '0.92rem' }}>
              <FontAwesomeIcon icon={faCalendarAlt} className="me-2" /> Month
            </div>
            <FontAwesomeIcon icon={faEllipsisV} className="text-secondary" />
          </Col>
        </Row>
        <div className="coin-glass-bg w-100">
          <div className="table-responsive">
            <Table className="coin-table table-borderless align-middle mb-0">
              <thead>
                <tr>
                  <th className='text-white'>Pair / Holdings</th>
                  <th className="text-center text-white">In Order Qty</th>
                  <th className='text-white'>Price / Avg Buy</th>
                  <th className="text-center text-white">Holdings</th>
                  <th className='text-white'>Total Value</th>
                  <th className='text-white'>Profit / Loss</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, idx) => (
                  <tr key={idx}>
                    <td >
                      <div className="coin-pair">
                        <span className="coin-icon">{item.icon}</span>
                        <span>
                          <span className="coin-name">{item.name}</span>
                          <span className="coin-tag ms-2">{item.tag}</span>
                        </span>
                      </div>
                    </td>
                    <td className="text-center text-white">{item.orderQty}</td>
                    <td>
                      <div className='text-white '>{item.price}</div>
                      <div className="text-white" style={{ fontSize: '0.78em' }}>{item.avgBuy}</div>
                    </td>
                    <td className="text-center text-white">{item.holdings}</td>
                    <td>
                      <div className='text-white'>{item.total}</div>
                      <div className="text-white" style={{ fontSize: '0.78em' }}>$10.00</div>
                    </td>
                    <td>
                      <span className={`coin-profit ${item.profitColor}`}>{item.profit}</span>
                      <div className="d-flex text-success align-items-center" style={{ fontSize: '0.82em' }}>
                        {item.profitPercent} {item.trendIcon}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      </Container>
    </>
  );
};

export default CoinAllocation;